<template>
  <div>
    <div class="account">
      <User></User>

      <div class="login">
        <Login v-if="!$gAuth.isAuthorized"></Login>
        <Logout v-if="$gAuth.isAuthorized"></Logout>
      </div>
    </div>
    <div class="notifications" v-if="mobile">
      <ToPaid></ToPaid>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: false,
    };
  },
  mounted() {
    this.mobile = this.$piggyBank.mobile;
    this.$root.$on("mobile", (mobile) => (this.mobile = mobile));

    this.$root.$on("logged", () => {
      this.$forceUpdate();
    });

    this.$root.$on("logged-out", () => {
      this.$forceUpdate();
    });
  },
};
</script>

<style lang="scss" scoped>
.account {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;

  .login {
    margin-top: 20px;
    text-align: center;
  }
}

.notifications {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>